export enum FeatureToggle {
  InsightsPortalAdsDashboard = 'rt_insights_portal_ads_dashboard',
  InsightsPortalAdsDashboardPromotions = 'rt_insights_portal_ads_dashboard_promotions',
  InsightsPortalDisplayReview = 'rt_insights_portal_display_review',
  InsightsPortalAdsDashboardRetailers = 'rt_insights_portal_ads_dashboard_retailers',
  InsightsCampaignInsights = 'rt_insights_campaign_insights',
  InsightsCampaignInsightsDisabledRetailers = 'rt_insights_campaign_insights_disabled_retailers',
  InsightsHideICStoreConfiguration = 'rt_insights_hide_ic_store_configuration',
  InsightsCreativeInsights = 'rt_insights_creative_insights',
  InsightsPortalCountrySelector = 'rt_insights_portal_country_selector',
  InsightsShowCampaignsEducationalBanner = 'rt_show_campaigns_educational_banner',
  InsightsDashboardBuilder = 'rt_insights_dashboard_builder',
  InsightsPortalFiltersInline = 'rt_insights_portal_filters_inline',

  InsightsPortalDrtMidterm = 'rt_insights_portal_drt_midterm_frontend_change',
  InsightsPortalDrtAdvancedFeatures = 'rt_insights_portal_drt_advanced_features',
  InsightsCancelledOrdersReport = 'rt_insights_cancelled_orders_report',
  InsightsPortalDrtDemandSource = 'rt_insights_portal_drt_demand_source',
  InsightsPortalFlyersDashboard = 'rt_insights_portal_flyers_dashboard',

  // moments
  campaignV2TemplateMomentEnabled = 'rt_campaigns_v2_template_moment_enabled',

  // Future Scheduled Orders
  FutureScheduledOrders = 'rt_future_scheduled_orders',

  IppAiAgent = 'rt_ipp_ai_agent',
  IppCaperDashboardRetailer = 'rt_ipp_caper_dashboard_retailer',
}
